'use client'

import * as React from 'react'

import { cn } from '../../utils/cn'
import { Input } from './Input'

function InputGroup({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="input-group"
      className={cn(
        'group/input-group relative flex w-full min-w-0 items-center rounded-lg border-[0.5px] transition-[color,box-shadow]',
        'bg-input hover:bg-input/90',
        'has-[:focus-visible]:border-ring',
        'aria-invalid:border-destructive-foreground',
        'data-[valid=true]:border-success-foreground',
        'has-[:disabled]:pointer-events-none has-[:disabled]:cursor-not-allowed has-[:disabled]:opacity-50',
        // Strip styles from nested input
        '[&_[data-slot=input-group-control]]:rounded-none [&_[data-slot=input-group-control]]:border-0 [&_[data-slot=input-group-control]]:bg-transparent [&_[data-slot=input-group-control]]:hover:bg-transparent [&_[data-slot=input-group-control]]:focus-visible:border-transparent',
        className
      )}
      {...props}
    />
  )
}

function InputGroupAddon({
  className,
  align = 'start',
  ...props
}: React.ComponentProps<'div'> & { align?: 'start' | 'end' }) {
  return (
    <div
      data-slot="input-group-addon"
      data-align={align}
      className={cn(
        'text-muted-foreground text-2xs flex shrink-0 cursor-text items-center select-none',
        align === 'start' && 'order-first pl-3',
        align === 'end' && 'order-last pr-3',
        className
      )}
      onClick={e => {
        if ((e.target as HTMLElement).closest('button')) return
        e.currentTarget.parentElement?.querySelector('input')?.focus()
      }}
      {...props}
    />
  )
}

function InputGroupText({ className, ...props }: React.ComponentProps<'span'>) {
  return (
    <span
      className={cn('text-muted-foreground text-2xs flex items-center', className)}
      {...props}
    />
  )
}

function InputGroupInput({ className, size, ...props }: React.ComponentProps<typeof Input>) {
  return (
    <Input
      data-slot="input-group-control"
      size={size}
      className={cn('flex-1', className)}
      {...props}
    />
  )
}

export { InputGroup, InputGroupAddon, InputGroupInput, InputGroupText }
